import React from 'react';

import PropTypes from 'prop-types';
import { green500 } from 'styles/colors';

function Candlestick(props) {
  const { x, y, width, height, speeds } = props;
  const legs = speeds.slice(1).map((speed, index) => speed - speeds[index]);
  const ratio = legs[1] === 0 ? 1 : Math.abs(height / legs[1]);
  return (
    <g stroke={green500} fill={green500} strokeWidth="2">
      <path
        d={`
          M ${x},${y}
          L ${x},${y + height}
          L ${x + width},${y + height}
          L ${x + width},${y}
          L ${x},${y}
        `}
      />
      {/* bottom line */}
      <path
        d={`
            M ${x + width / 2}, ${y + height}
            v ${legs[0] * ratio}
          `}
      />
      {/* top line */}
      <path
        d={`
            M ${x + width / 2}, ${y}
            v ${-legs[2] * ratio}
          `}
      />
    </g>
  );
}

Candlestick.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  speeds: PropTypes.arrayOf(PropTypes.number),
};
export default Candlestick;
